<div class="shape" [ngClass]="shapeClass"></div>
{{ label }}
